import APIService from '../api.service';

export const List = (params) => {
    return APIService.get(`/v01/payments`, {
        params: {
            ...params
        },
    });
};

export const Create = (body, config = {}) => {
    return APIService.post(`/v01/payments`, body, config);
};

export const Detail = (id) => {
    return APIService.get(`/v01/payments/${id}`);
};

export const BulkCreate = (body, config = {}) => {
    return APIService.post(`/v01/payments/bulk`, body, config);
};

export const Update = (id, body, config = {}) => {
    return APIService.put(`/v01/payments/${id}`, body, config);
};

const PaymentService = {
    List,
    Create,
    BulkCreate,
    Detail,
    Update,
};

export default PaymentService;
